export default __webpack_public_path__ + "34398231a5faf50c486aa93092f0d880.png";